<div class="container-fluid">
    <h1 class="error-message">
        <span l10nTranslate>Errors.Title</span>
        <span *ngIf="errorMessage" l10nTranslate>{{errorMessage}}</span>
    </h1>
</div>
<samplicity-footer></samplicity-footer>